import type { TutorialMissionKey } from "@/constants/tutorialMissions";

/**
 * 画面の操作が成功したことを、チュートリアルミッションの仕組み (TutorialMissionHost) に知らせる。
 *
 * 各画面は操作の API が成功した直後に reportTutorialAction("clock_in") のように呼ぶだけでよい。
 * クリア済みかどうかの判定・ポイントの付与・お祝いの表示は Host が行う。
 *
 * Host がまだ画面に無い瞬間 (ページを開いた直後など) に呼ばれても取りこぼさないよう、
 * 知らせはいったんモジュール内に溜め、Host が取り出す (drainTutorialActions)。
 */

export const TUTORIAL_ACTION_EVENT = "gc:tutorial:action";

const pending: TutorialMissionKey[] = [];

export function reportTutorialAction(key: TutorialMissionKey): void {
  if (typeof window === "undefined") return;
  if (!pending.includes(key)) pending.push(key);
  window.dispatchEvent(new Event(TUTORIAL_ACTION_EVENT));
}

/** 溜まっている知らせを全部取り出す (取り出した分は消える) */
export function drainTutorialActions(): TutorialMissionKey[] {
  return pending.splice(0, pending.length);
}
